<ng-template #template let-form>
  <ng-container [formGroup]="form">
    <div>
      <h3 class="drawer-title">Ajouter un loyer</h3>
      <div class="form-sct-container">
        <input formControlName="id" type="hidden" />

        <pr-input
          [label]="'Loyer perçus'"
          [suffix]="'€/mois'"
          [derrors]="derrors"
          ><input formControlName="amount" type="text"
        /></pr-input>

        <pr-input label="Fréquence" [derrors]="derrors">
          <mat-select formControlName="frequency">
            @for (periodicityType of periodicityTypes; track periodicityType) {
              <mat-option [value]="periodicityType.id">
                {{ periodicityType.value | translate }}
              </mat-option>
            }
          </mat-select>
        </pr-input>

        <pr-input-date
          formControlName="startDate"
          label="Date de début"
          [derrors]="derrors"
        ></pr-input-date>

        <pr-input-radio
          formControlName="current"
          label="Loyers courants"
          toggleBgEmpty="true"
        ></pr-input-radio>

        <pr-input-date
          formControlName="endDate"
          label="Date de fin"
          [hidden]="form.get('current').value"
          [derrors]="derrors"
        ></pr-input-date>
      </div>
    </div>
    <div [formGroup]="form.get('tenant')">
      <h3 class="drawer-title">Informations sur le locataire</h3>
      <div class="form-sct-container">
        <pr-input [label]="'Nom'" [derrors]="derrors"
          ><input formControlName="lastName" type="text"
        /></pr-input>

        <pr-input [label]="'Prénom'" [derrors]="derrors"
          ><input formControlName="firstName" type="text"
        /></pr-input>

        <pr-input [label]="'Adresse Email'" [derrors]="derrors"
          ><input formControlName="email" type="text" />
        </pr-input>

        <pr-input
          [label]="'Téléphone mobile'"
          [phoneMask]="true"
          [derrors]="derrors"
        >
          <input
            formControlName="phone"
            type="text"
            mask="00 00 00 00 00"
            [showMaskTyped]="true"
          />
        </pr-input>
      </div>
    </div>
  </ng-container>
</ng-template>

<div [formGroup]="form">
  <ul formArrayName="rents">
    <pr-form-list-item
      *ngFor="let item of rents.controls as FormGroup; let i = index"
      [formGroup]="item"
      [index]="i"
      headerClass="horizontal-title-list-item"
      buttonIconVbWidth="23"
      buttonIconVbHeight="23"
      buttonStyle="label"
      buttonClass="btn-nostyle neutral btn-list-remove"
      itemName="ce loyer"
      [context]="this"
      [derrors]="derrors"
      (onDelete)="onDelete($event)"
      (onValidate)="validate(item)"
    >
      @if (item.get('amount').value) {
        <div class="pr-form-list-title-primary">Loyer {{ i + 1 }}</div>
        <div>
          {{ item.get('amount').value | currency: 'EUR' : 'symbol' : '.0-0' }}
        </div>
        @if (
          item.get('startDate').value &&
          item.get('startDate').status === 'VALID'
        ) {
          <div class="pr-form-list-title-tertiary">
            {{ item.get('startDate').value | date: 'shortDate' }}
            @if (item.get('endDate').value) {
              au {{ item.get('endDate').value | date: 'shortDate' }}
            }
            @if (!item.get('endDate').value) {
              à Auj.
            }
          </div>
        }
      } @else {
        <div class="pr-form-list-title-primary">Nouveau montant</div>
      }
      <ng-container
        item
        [ngTemplateOutlet]="template"
        [ngTemplateOutletContext]="{ $implicit: item }"
      ></ng-container>
    </pr-form-list-item>
    @if (derrors && form.controls.errors) {
      <ul class="pr-form-list-errors">
        @if (form.controls.errors) {
          <li>Vous devez declarer au moins un montant</li>
        }
      </ul>
    }
    <div class="pr-form-list-add">
      <pr-button
        clazz="btn-list-add neutral"
        rightIcon="sp-plus"
        label="Ajouter un loyer perçu"
        (onClick)="EaRentFormService.addModel(entity, form.controls)"
      >
      </pr-button>
    </div>
  </ul>
</div>
